import { Api } from "../config/request";

export default {
  getUploadUrl(payload) {
    return Api.post("/bulk-upsert-shelters", payload);
  },
};
